import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { isEmpty } from 'lodash';
import { Icon } from '@unite-us/ui';
import generateUUID from '../../utils/generateUUID';
import FilePreview from './FilePreview';
import './stylesheets/FileUpload.scss';
var MAX_FILE_SIZE = 10000000;
export var FileUpload = function FileUpload(_ref) {
  var className = _ref.className,
    children = _ref.children,
    multiple = _ref.multiple,
    rejectedFiles = _ref.rejectedFiles,
    uploadedFiles = _ref.uploadedFiles,
    setRejectedFiles = _ref.setRejectedFiles,
    setUploadedFiles = _ref.setUploadedFiles,
    acceptedFileTypes = _ref.acceptedFileTypes;
  var onDrop = function onDrop(acceptedFiles) {
    var _context;
    var fileUploadWithIdAndPreview = _mapInstanceProperty(acceptedFiles).call(acceptedFiles, function (file) {
      return {
        file: file,
        tempId: generateUUID(),
        preview: _URL.createObjectURL(file)
      };
    });
    setRejectedFiles({
      filesTooBig: [],
      filesWrongType: []
    });
    setUploadedFiles(multiple ? _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(uploadedFiles), _toConsumableArray(fileUploadWithIdAndPreview)) : fileUploadWithIdAndPreview);
  };
  var onDropRejected = function onDropRejected(fileRejections) {
    var _fileRejections$reduc = _reduceInstanceProperty(fileRejections).call(fileRejections, function (acc, rejectedFile) {
        if (rejectedFile.size > MAX_FILE_SIZE && !_includesInstanceProperty(acceptedFileTypes).call(acceptedFileTypes, rejectedFile.type)) {
          var _context2;
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesTooBigAndWrongType: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(acc.filesTooBigAndWrongType), [rejectedFile.name])
          });
        }
        if (rejectedFile.size > MAX_FILE_SIZE) {
          var _context3;
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesTooBig: _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(acc.filesTooBig), [rejectedFile.name])
          });
        }
        if (!_includesInstanceProperty(acceptedFileTypes).call(acceptedFileTypes, rejectedFile.type)) {
          var _context4;
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesWrongType: _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(acc.filesWrongType), [rejectedFile.name])
          });
        }
        return acc;
      }, {
        filesTooBig: [],
        filesWrongType: [],
        filesTooBigAndWrongType: []
      }),
      filesTooBig = _fileRejections$reduc.filesTooBig,
      filesWrongType = _fileRejections$reduc.filesWrongType,
      filesTooBigAndWrongType = _fileRejections$reduc.filesTooBigAndWrongType;
    setRejectedFiles({
      filesTooBig: filesTooBig,
      filesWrongType: filesWrongType,
      filesTooBigAndWrongType: filesTooBigAndWrongType
    });
  };
  var _useDropzone = useDropzone({
      accept: acceptedFileTypes,
      maxSize: MAX_FILE_SIZE,
      onDrop: onDrop,
      onDropRejected: onDropRejected,
      multiple: multiple
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  var _rejectedFiles$filesT = rejectedFiles.filesTooBig,
    filesTooBig = _rejectedFiles$filesT === void 0 ? [] : _rejectedFiles$filesT,
    _rejectedFiles$filesW = rejectedFiles.filesWrongType,
    filesWrongType = _rejectedFiles$filesW === void 0 ? [] : _rejectedFiles$filesW,
    _rejectedFiles$filesT2 = rejectedFiles.filesTooBigAndWrongType,
    filesTooBigAndWrongType = _rejectedFiles$filesT2 === void 0 ? [] : _rejectedFiles$filesT2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, filesTooBigAndWrongType.length ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "file-too-big-and-wrong-type-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "pb-1 mr-2 fill-current text-validation-red",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'text-sm text-validation-red'
  }, "This file type is not supported and exceeds the maximum upload size of 10MB."), /*#__PURE__*/React.createElement("div", {
    className: 'text-sm text-validation-red mt-2'
  }, "Accepted formats are CSV .DOC .DOCX .PDF .RTF .TXT .XLS .XLSX .GIF .JPG .JPEG .PNG .MP3 .M4A .WAV .WMA"))), /*#__PURE__*/React.createElement("ul", null, _mapInstanceProperty(filesTooBigAndWrongType).call(filesTooBigAndWrongType, function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, filesWrongType.length ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(filesTooBigAndWrongType.length ? 'mt-3' : ''),
    "data-testid": "file-wrong-type-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "pb-1 mr-2 fill-current text-validation-red",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-sm text-validation-red'
  }, "This file type is not supported. Accepted formats are CSV .DOC .DOCX .PDF .RTF .TXT .XLS .XLSX .GIF .JPG .JPEG .PNG .MP3 .M4A .WAV .WMA")), /*#__PURE__*/React.createElement("ul", null, _mapInstanceProperty(filesWrongType).call(filesWrongType, function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, filesTooBig.length ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(filesWrongType.length || filesTooBigAndWrongType.length ? 'mt-3' : ''),
    "data-testid": "file-too-big-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "pb-1 mr-2 fill-current text-validation-red",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-sm text-validation-red'
  }, "The following file exceeds the maximum upload size of 10MB")), /*#__PURE__*/React.createElement("ul", null, _mapInstanceProperty(filesTooBig).call(filesTooBig, function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
    className: cx('mt-5 mb-3 file-upload-dropzone', className)
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-upload-dropzone__preview"
  }, children || /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: "file-upload-dropzone__preview__uploader-link"
  }, "Choose file"), " or drag and drop to upload"), !isEmpty(uploadedFiles) && _mapInstanceProperty(uploadedFiles).call(uploadedFiles, function (_ref2) {
    var file = _ref2.file,
      tempId = _ref2.tempId,
      preview = _ref2.preview;
    return /*#__PURE__*/React.createElement("div", {
      key: tempId,
      className: "file-upload-dropzone__preview__preview-item",
      "data-testid": "file-preview"
    }, /*#__PURE__*/React.createElement(FilePreview, {
      contentType: file.type,
      preview: preview
    }), /*#__PURE__*/React.createElement("div", {
      className: "file-upload-dropzone__preview__file-name"
    }, file.name));
  })), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    "data-testid": "file-upload-input"
  }))));
};
FileUpload.propTypes = {
  className: PropTypes.string,
  multiple: PropTypes.bool,
  children: PropTypes.node,
  rejectedFiles: PropTypes.object.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  setRejectedFiles: PropTypes.func.isRequired,
  setUploadedFiles: PropTypes.func.isRequired,
  acceptedFileTypes: PropTypes.string
};
FileUpload.defaultProps = {
  className: '',
  children: null,
  multiple: false,
  acceptedFileTypes: "text/csv, application/msword,\n  application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n  application/pdf, application/rtf, text/rtf, application/x-rtf, text/plain,\n  application/excel, application/vnd.ms-excel, application/x-excel, application/x-msexcel,\n  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n  application/vnd.ms-excel.sheet.binary.macroEnabled.12,\n  application/vnd.ms-excel,\n  application/vnd.ms-excel.sheet.macroEnabled.12,\n  image/gif, image/jpg, image/jpeg, image/png, audio/mpeg, audio/m4a,\n  audio/x-m4a, audio/wav, audio/x-wav, audio/x-ms-wma, video/x-ms-wma"
};
export default FileUpload;
//# sourceMappingURL=FileUpload.js.map